<template>
    <div class="wrap">

        <h1>Поиск</h1>

        <form class="form">
            <input :disabled="disabled" placeholder="Что будем искать?" class="search" v-model="search" type="text" name="search">
            <button :disabled="disabled" class="site-btn" type="submit" @click.prevent="onSearch">Найти</button>
        </form>

        <div class="results" v-if="isSearch">
            <h2>Результаты поиска</h2>
            <ul class="site-list" v-if="results.length">
                <li class="site-item" v-for="result in results" :key="result.site.title">
                    <a @click.prevent="open(result.site.url, result.site.site)" :href="result.site.url" class="link">{{result.site.title}}</a>
                    <span class="desc">{{result.site.desc}}</span>
                    <span class="site">{{result.site.site}}</span>
                </li>
            </ul>
            <div v-else class="no-results">
                По вашему запросу "<i>{{searchText}}</i>" ничего не найдено!
            </div>
        </div>
    </div>
</template>
<script>
    import data from './data.json'
    import mixin from '@/web/mixin.js'

    export default {
        mixins: [mixin],

        data () {
            return {
                isSearch: false,
                minChar: 3,
                search: '',
                searchText: '',
                sites: data.sites,
                results: [],
                disabled: false
            }
        },
        methods: {
            onSearch () {
                let words = this.search.split(' ').filter(word => word.length >= this.minChar)
                this.isSearch = true
                this.searchText = this.search

                if (!words.length) {
                    this.results = []
                    return
                }
                let results = this.getResults(words)
                let filtered = this.filterResults(results)
                let sorted = this.sortResults(filtered)
                this.results = sorted
            },
            getResults (words) {
                return this.sites.map(site => {
                    return {
                        weight: this.getWeight(site.keywords, words),
                        site
                    }
                })
            },
            filterResults (results = []) {
                return results.filter(item => item.weight > 0)
            },
            sortResults (results = []) {
                return results.sort((a, b) => b.weight - a.weight)
            },
            getWeight (keywords = [], words = []) {
                let result = 0
                keywords.forEach(keyword => {
                    words.forEach(word => {
                        if (keyword.search(word) > -1 || word.search(keyword) > -1) {
                            result++
                        }
                    })
                })
                return result
            }
        },
        created () {
            if ( this.$route.query.q) {
                this.search = this.$route.query.q
                this.onSearch()
            }
            if ( this.$route.query.disabled) {
                this.disabled = true
            }
        },
        mounted () {
            this.event('view', {site: 'search'})
        }
    }
</script>

<style scoped lang="stylus">
    .wrap {
        width: 800px;
        margin: 0 auto;
        padding: 25px;
        box-sizing: border-box;
    }

    .form {
        display: flex;
        border: 2px solid #006db2;
        position: relative;
        margin: 30px auto;
    }

    .form::after {
        content: "";
        position: absolute;
        left: 100%;
        top: -2px;
        bottom: -2px;
        border-radius: 0 50% 50% 0;
        background: #006db2;
        width: 30px;
    }

    .search {
        padding: 10px;
        flex: 1 1;
    }

    .site-btn {
        outline: none;
        background-color: #006db2;
        border: 0 none;
        padding: 10px 0 10px 20px;
        color: #fff;
    }
    h1 {
        font-family: Roboto;
        font-size: 30px;
    }
    h2 {
        font-family: Roboto;
        font-size: 20px;
    }
    .results {
        margin-top: 40px;
    }
    .site-list {
        display: block;
        padding-top: 20px;
        list-style: none;
    }
    .site-item {
        padding: 10px 0;
        border-bottom: 1px solid #b5b5b5;
    }
    .item:last-child {
        border-bottom: 0 none;
    }
    .link {
        font-size: 16px;
        color: #006db2;
        margin-bottom: 4px;
    }
    .desc {
        display: block;
        font-size: 14px;
    }
    .site {
        color: #b30000;
    }
    .no-results {
        text-align center
        padding 30px 0
    }
</style>